export default "__VITE_ASSET__Dbd$dIMU__"